"use client";

import ChevronDown from "@/components/library/icons/ChevronDown";
import { Navigation as NavigationType } from "@/types/Navigation";
import Link from "next/link";

const Navigation = ({ navigation }: { navigation: NavigationType }) => {
  const isExternalUrl = (url: string) => url.startsWith("http");

  const navigationLinkNodes = navigation.map((primaryLink) => {
    if (primaryLink.subnavigation && primaryLink.subnavigation.length > 0) {
      const subnavigationNodes = primaryLink.subnavigation.map(
        (secondaryLink) => {
          const external = isExternalUrl(secondaryLink.href);

          return (
            <li className="secondary-link" key={secondaryLink.label}>
              {external ? (
                <a
                  href={secondaryLink.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="label">{secondaryLink.label}</span>
                </a>
              ) : (
                <Link href={secondaryLink.href}>
                  <span className="label">{secondaryLink.label}</span>
                </Link>
              )}
            </li>
          );
        }
      );

      return (
        <li className="primary-link parent" key={primaryLink.label}>
          <Link href="#">
            <span className="label">
              {primaryLink.label}
              <span className="chevron-down-container">
                <ChevronDown />
              </span>
            </span>
          </Link>
          <ul className="secondary-navigation">{subnavigationNodes}</ul>
        </li>
      );
    } else {
      const external = isExternalUrl(primaryLink.href);

      return (
        <li className="primary-link" key={primaryLink.label}>
          {external ? (
            <a
              href={primaryLink.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="label">{primaryLink.label}</span>
            </a>
          ) : (
            <Link href={primaryLink.href}>
              <span className="label">{primaryLink.label}</span>
            </Link>
          )}
        </li>
      );
    }
  });

  return (
    <nav aria-label="Main navigation">
      <ul className="primary-navigation">{navigationLinkNodes}</ul>
    </nav>
  );
};

export default Navigation;
